<template>
  <div id="app">
    <!-- Preloader Start -->
	<div class="preloader">
		<div class="loading-container">
			<div class="loading"></div>
			<div id="loading-icon"><img src="https://firebasestorage.googleapis.com/v0/b/usdadental-6e620.appspot.com/o/images%2FLogo-usda-TRANSPARENTE.png?alt=media&token=26e27fc0-8969-41b6-8fce-dca55b81ba85" alt=""></div>
		</div>
	</div>
  <header class="main-header">
		<div class="header-sticky">
			<nav class="navbar navbar-expand-lg">
				<div class="container">
					<!-- Logo Start -->
					<a class="navbar-brand" href="">
						<img src="https://firebasestorage.googleapis.com/v0/b/usdadental-6e620.appspot.com/o/images%2FLogo.png?alt=media&token=35341573-07f1-43e2-a49e-61939d5bee12"  alt="Logo">
					</a>
					<!-- Logo End -->

					<!-- Main Menu Start -->
					<div class="collapse navbar-collapse main-menu">
                        <div class="nav-menu-wrapper">
                            <!-- <ul class="navbar-nav mr-auto" id="menu">
                                <li class="nav-item submenu"><a class="nav-link" href="">Home</a>
                                   
                                </li>                                
                                <li class="nav-item"><a class="nav-link" href="">About Us</a></li>
                                <li class="nav-item"><a class="nav-link" href="">Services</a></li>
                                <li class="nav-item submenu"><a class="nav-link" href="#">Pages</a>
                                </li>
                                <li class="nav-item"><a class="nav-link" href="">Contact Us</a></li>
                                <li class="nav-item highlighted-menu"><a class="nav-link" href="">agendar cita</a></li>                               
                            </ul> -->
                        </div>
                        <!-- Let’s Start Button Start -->
                        <div class="header-btn d-inline-flex">
                            <a href="https://wa.link/kkyua5" class="btn-default">agendar cita</a>
                        </div>
                        <!-- Let’s Start Button End -->
					</div>
					<!-- Main Menu End -->
					<div class="navbar-toggle"></div>
				</div>
			</nav>
			<div class="responsive-menu"></div>
		</div>
	</header>
    <router-view />
    <CTA />
    <About />
    <Services />
    <WhyChoose />
    <OurTeam />
    <Testimonial />
    <Contact />
    <Footer />
  </div>
</template>
<script>
import CTA from "@/components/cta.vue";
import About from "@/components/about.vue";
import Services from "@/components/services.vue";
import WhyChoose from "@/components/whychoose.vue";
import OurTeam from "@/components/ourteam.vue";
import Testimonial from "@/components/testimonial.vue";
import Contact from "@/components/contact.vue";
import Footer from "@/components/footer.vue";
export default {

  components: {
    CTA,
    About,
    Services,
    WhyChoose,
    OurTeam,
    Testimonial,
    Contact,
    Footer
  },
};
</script>
